import React, { useEffect, useState } from 'react'
import { base_url } from '../../utils/AxiosConfig';
import { toast } from 'react-toastify';
import axios from 'axios';
import SnackbarNotification from '../../utils/SnackbarNotification';


const AddPayroll = ({popUpData, setpopUpData}) => {


  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
        let companyCode = null

        if (storedUserDataArray) {
          companyCode = storedUserDataArray[0].cmpcode
        }

  const [type, setType] = useState('');
  const [categoryOptions, setCategoryOptions] = useState([]);

  const [isModalVisible, setModalVisible] = useState(true); 

  const [frequency,setFrequency] = useState(1)


  const getCurrentMonthStart = () => {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-01`;
};



  const [formData, setFormData] = useState({
    EmpID: '',
    Category: 'Deduction', // default value
    Amount: '',
    // Adate: '',
    Adate: getCurrentMonthStart(),
    Notes: ''
  });

  const cmpCode = companyCode; // Hard-coded value

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };


  const dataReset = () => {
    setFormData({
      EmpID: '',
      Category: 'Deduction', // Reset to default value
      Amount: '',
      Adate: '',
      Notes: ''
    });
    setFrequency(1); // Reset frequency to default value
    setType(''); // Reset any other fields as needed
    setCategoryOptions([]); // Reset category options if necessary
  }

  // Handle form submission
  const handleSubmit = async(e) => {
    e.preventDefault();

    const postData = JSON.stringify(dataToSend)

    console.log('postData',postData)

  // Send POST request using axios
  try {
    console.log('${base_url}/api/PersonalInfoAdditionReg',`${base_url}api/PersonalInfoAdditionReg`)
    const response = await axios.post(`${base_url}/api/PersonalInfoAdditionReg`, postData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (response.status === 200) {
      console.log('Success:', response.data);
      // toast.success('Data Send Successfully')
  showSnackbar('success', 'Data Sent Successfully');
      // closeModal()

      setFormData({
        EmpID: '',
        Category: 'Deduction', // Reset to default value
        Amount: '',
        Adate: '',
        Notes: ''
      });
      setFrequency(1); // Reset frequency to default value
      setType(''); // Reset any other fields as needed
      setCategoryOptions([]); // Reset category options if necessary
      // Handle success response
    } else {
      console.error('Unexpected status code:', response.status);
      // toast.error('Unexpected status code:')
      // toast.error(':')
       showSnackbar('error', 'Unexpected status code');
      // Handle any other status codes
    }
  } catch (error) {
    console.error('Error sending data:', error.response || error.message);
    // toast.error('Error sending data:')
        showSnackbar('error', 'Error sending data.');
    // Handle error during the request
  }

    console.log("Data to send:", postData);
    // You can now send this `dataToSend` to your API
  };

  const deductionOptions = [
    { value: 'Certification', label: 'Certification' },
    { value: 'Fine', label: 'Fine' },
    { value: 'Loan', label: 'Loan' },
    { value: 'Tools', label: 'Tools' },
    { value: 'Other', label: 'Other' }
  ];

  const additionOptions = [
    { value: 'Certification', label: 'Certification' },
    { value: 'Health Insurance', label: 'Health Insurance' },
    { value: 'Inter-Office Purchases', label: 'Inter-Office Purchases' },
    { value: 'Medical', label: 'Medical' },
    { value: 'Loans', label: 'Loans' },
    { value: 'Retirement Contributions', label: 'Retirement Contributions' },
    { value: 'Special Duty', label: 'Special Duty' },
    { value: 'Tools', label: 'Tools' },
    { value: 'Uniform', label: 'Uniform' },
  ];

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setType(selectedType);

    if (selectedType === 'Deduction') {
      setCategoryOptions(deductionOptions);
    } else if (selectedType === 'Addition') {
      setCategoryOptions(additionOptions);
    }
  };


  // Helper function to increment the date by 1 month
  const addMonths = (date, months) => {
    const d = new Date(date);
    d.setMonth(d.getMonth() + months);
    
    // Handle end of month issues
    if (d.getDate() < new Date(date).getDate()) {
      d.setDate(0); // Roll back to last day of the previous month
    }
    return d;
  };

  // Function to create the data array based on frequency
  const createDataArray = () => {
    if (!formData.Adate) {
      return []; // Ensure there's an initial date before processing
    }

    return Array.from({ length: frequency }, (_, index) => {
      const adjustedDate = addMonths(formData.Adate, index);

      return {
        CmpCode: cmpCode,
        EmpID: popUpData?.EmpId,
        Category: type,
        Amount: formData.Amount / frequency,
        Adate: adjustedDate.toISOString().split('T')[0], // Convert to YYYY-MMM-DD format
        Notes: formData.Notes
      };
    });
  };

  const dataToSend = createDataArray();

  // console.log(dataToSend,'dataToSend'); // To view the result


  // const closeModal = () => {
  //   setModalVisible(false);


  //   // Remove the modal backdrop
  //   const backdrop = document.querySelector('.modal-backdrop');
  //   if (backdrop) {
  //     backdrop.parentNode.removeChild(backdrop);
  //   }
  // };

  // console.log(type,'type')

  // console.log(isModalVisible,'isModalVisible')
useEffect(() => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach((el) => new window.bootstrap.Tooltip(el));
}, []);



        const [snackbar, setSnackbar] = useState({
        open: false,
        severity: 'success',
        message: '',
      });
  
          const showSnackbar = (severity, message) => {
      setSnackbar({ open: true, severity, message });
    };
  
    const handleClose = () => {
      setSnackbar({ ...snackbar, open: false });
    };


  return (
//     <style>
//       .disabled-btn {
//   background-color: #ccc !important;
//   border-color: #ccc !important;
//   cursor: not-allowed;
// }
// </style>
  <div>
    <div
    //  className={`modal fade ${isModalVisible ? '' : 'hidden'}`}
    class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title  text-secondary fs-small" id="staticBackdropLabel">Payroll Additions/Deductions</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={()=>{
              dataReset()
              setpopUpData('')
              }}></button>
          </div>

          <div class="modal-body">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6">
                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Emp ID</label>
                  <input type="text" class="form-control" value={popUpData?.EmpId}  disabled/>
                </div>

                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Emp Name</label>
                  <input type="text" class="form-control" value={popUpData?.Name}  disabled/>
                </div>

              <div class="mb-3">
                <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Designation</label>
                <input type="text" class="form-control"  value={popUpData?.JobTitle}  disabled/>
              </div>

              <div className="mb-3">
                <label className="form-label fs-small text-secondary">Type</label>
                <select className="form-select" value={type} onChange={handleTypeChange}>
                  <option value="" disabled>Select Type</option>
                  <option value="Deduction">Deduction</option>
                  <option value="Addition">Addition</option>
                </select>
              </div>

            </div>
            <div className="col-md-6">

                {/* <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Starting Date</label>
                  <input type="date" 
                    className="form-control" 
                    name="Adate"
                    value={formData.Adate}
                    onChange={handleInputChange} 
                  />
                </div> */}


          <div class="mb-3">
            <label for="exampleInputMonth" class="form-label fs-small text-secondary">
              Starting Month
            </label>
            <input
              type="month"
              className="form-control"
              name="Adate"
              value={formData.Adate.slice(0, 7)} // only show YYYY-MM format in the input
              onChange={(e) => {
                const selectedMonth = e.target.value;
                // Set the date to the first day of the selected month
                handleInputChange({
                  target: {
                    name: 'Adate',
                    value: `${selectedMonth}-01`, // Format the date as YYYY-MM-01
                  },
                });
              }}
            />
          </div>



                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Amount</label>
                  <input type="text" class="form-control"  name="Amount"
                    value={formData.Amount}
                    onChange={handleInputChange}  
                  />
                  
                </div>

                <div class="mb-3">
                  <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Frequency</label>
                  <input type="text" class="form-control" value={frequency} onChange={(e) => setFrequency(e.target.value)}/>
                  
                </div>


                <div className="mb-3">
                  <label className="form-label fs-small text-secondary">Category</label>
                  <select className="form-select"
                    name="Notes"
                    value={formData.Notes}
                    onChange={handleInputChange}
                  >
                    <option value="" disabled>Select Category</option>
                    {categoryOptions.map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </select>
                </div>

                </div>
              </div>
          

            </div>
          </div>
          <div class="modal-footer">
          
<div className="relative inline-block">
  <button
    type="button"
    onClick={handleSubmit}
    disabled={!type || !formData.Notes}
    title={!type || !formData.Notes ? "Please select both Type and Category" : ""}
    className={`px-2 py-1 rounded items-center text-white text-sm font-sm transition duration-300
      ${(!type || !formData.Notes)
        ? 'bg-gray-300 cursor-not-allowed'
        : 'bg-blue-600 hover:bg-blue-700'}
    `}
  >
    Generate
  </button>
</div>
       <SnackbarNotification
                    open={snackbar.open}
                    severity={snackbar.severity}
                    message={snackbar.message}
                    onClose={handleClose}
            
                  />
      </div>

          <div class="modal-body scroll" style={{ maxHeight: '400px', overflow: 'auto' }}>
            <table class="table">
                      <tbody>
                        <tr className="">
                          <td>SI Now</td>
                          <td>Category</td>
                          <td>Amount</td>
                          <td>Payroll</td>
                          <td>Remarks</td>
                        </tr>

                        {
                          dataToSend && dataToSend.length > 0 && dataToSend.map((item,index) => (
                            <tr className="dataTr" key={index}>
                              <td>{index+1}</td>
                              <td>{item.Category}</td>
                              <td>{item.Amount}</td>
                              <td>{item.Adate}</td>
                              <td>{item.Notes}</td>
                          </tr>
                          ))
                        }

                        {
                          dataToSend && dataToSend.length === 0 &&
                          <tr>
                            <td colSpan={5} style={{color:'red'}}>
                              No Data Available
                            </td>
                          </tr>
                        }
                      
                      </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default AddPayroll
